/** Fits desktop page actions around bounded native pickers without changing their rendering. */
import { fitCluster, type ClusterFit } from './headerOverflow';
import type { MobileHeaderAction } from './types';

export function fitDesktopHeaderActions(
  actions: MobileHeaderAction[],
  budget: number,
  interceptedIds: ReadonlySet<string>,
  compactLabels: boolean,
  pickerWidth: number,
): ClusterFit {
  const pickers = actions.filter(action => interceptedIds.has(action.id));
  const ordinary = actions.filter(action => !interceptedIds.has(action.id)).map(action =>
    compactLabels && action.icon && action.emphasis !== 'primary'
      ? { ...action, label: undefined, desktopLabel: undefined }
      : { ...action, label: action.desktopLabel ?? action.label });
  // The picker wrapper bounds native selects, whose widest option otherwise
  // makes the closed control wider than the action's label estimate.
  const fit = fitCluster(ordinary, budget - pickers.length * (pickerWidth + 12), () => false);
  const visibleById = new Map([...pickers, ...fit.visible].map(action => [action.id, action]));
  return {
    visible: actions.flatMap(action => visibleById.has(action.id) ? [visibleById.get(action.id)!] : []),
    collapsed: fit.collapsed,
  };
}
